import React, { useState, useEffect } from "react";
import $ from "jquery";
import { Link } from "react-router-dom";
import logOut from '../helpers/logout';
import { useContext } from "react";
import { UserContext } from "../context/UserContext";
import "../assets/css/custom-overrides.css";

const rolePlay = localStorage.getItem("play");
const profileURL = (rolePlay === "employer") ? "/employer/employer-profile/profile" : "/candidate/candidate-profile/profile";

const Header = () => {
    // const profilePic = useContext(UserContext); //localStorage.getItem("profilePic");
    const { profilePic, availability } = useContext(UserContext);
    
    // const {} = useContext(UserContext); //localStorage.getItem("availability") || "Available"; // default fallback
    console.log("availability :::: ",availability);
//   const [menuOpen, setMenuOpen] = useState(false);

//   const toggleMenu = () => {
//     setMenuOpen(!menuOpen);
//   };
  console.log("Header Component Loaded");
//   useEffect(() => {
//     $(".hamburger").on("click", function () {
//       $(".nk-sidebar").toggleClass("active"); // Toggle sidebar
//       $(".content").toggleClass("expanded"); // Adjust content area
//     });

//     return () => {
//       $(".hamburger").off("click"); // Cleanup to prevent multiple event bindings
//     };
//   }, []);
  return (
    <>
      <div className="nav-header">
            <div className="brand-logo">
                <a href="/home">
                    {/* <b className="logo-abbr"><img src="images/logo.png" alt=""/> </b>
                    <span className="logo-compact"><img src="./images/logo-compact.png" alt=""/></span> */}
                    <span className="brand-title">
                        {/* {process.env.REACT_APP_APPL_NAME} */}
                       <img src="/assets/img/logo-preview.png" alt="Logo"
  style={{
    backgroundColor: 'transparent', // or match the parent background
    mixBlendMode: 'multiply' // optional: blends black out on light background
  }}/>
                    </span>
                </a>
            </div>
        </div>

<div className="header">    
    <div className="header-content clearfix">
        
        
       
        <div className="header-right">
            <ul className="clearfix">
                {localStorage.getItem("play") === "jobSeeker" &&
                    menuItems.map((item, index) => (
                        <li className="icons dropdown d-none d-md-flex" key={index}>
                        {item.subItems ? (
                            <>
                            <a
                                href="javascript:void(0)"
                                className="log-user"
                                data-bs-toggle="dropdown"
                            >
                                <span>{item.label}</span>
                                <i className="fa fa-angle-down f-s-14" aria-hidden="true"></i>
                            </a>
                            <div className="drop-down dropdown-language animated fadeIn dropdown-menu">
                                <div className="dropdown-content-body">
                                <ul>
                                    {item.subItems.map((subItem, subIndex) => (
                                        <li className="icons dropdown d-none d-md-flex" key={index}>
                                            {typeof subItem === "string" ? (
                                                <a href="javascript:void(0)">{subItem}</a>
                                                ) : (
                                                <a href={subItem.link || "javascript:void(0)"}>
                                                    {subItem.label}
                                                </a>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                                </div>
                            </div>
                            </>
                        ) : (
                            <a href={item.link} className="log-user">
                            <span>{item.label}</span>
                            </a>
                        )}
                        </li>
                ))}

                
                {/* <li className="icons dropdown"><a href="javascript:void(0)" data-bs-toggle="dropdown">
                        <i className="mdi mdi-email-outline"></i>
                        <span className="badge badge-pill gradient-1">3</span>
                    </a>
                    <div className="drop-down animated fadeIn dropdown-menu">
                        <div className="dropdown-content-heading d-flex justify-content-between">
                            <span className="">3 New Messages</span>  
                            <a href="javascript:void()" className="d-inline-block">
                                <span className="badge badge-pill gradient-1">3</span>
                            </a>
                        </div>
                        <div className="dropdown-content-body">
                            <ul>
                                <li className="notification-unread">
                                    <a href="javascript:void()">
                                        <img className="float-left mr-3 avatar-img" src="assets/images/avatar/1.jpg" alt="" />
                                        <div className="notification-content">
                                            <div className="notification-heading">Saiful Islam</div>
                                            <div className="notification-timestamp">08 Hours ago</div>
                                            <div className="notification-text">Hi Teddy, Just wanted to let you ...</div>
                                        </div>
                                    </a>
                                </li>
                                <li className="notification-unread">
                                    <a href="javascript:void()">
                                        <img className="float-left mr-3 avatar-img" src="assets/images/avatar/2.jpg" alt="" />
                                        <div className="notification-content">
                                            <div className="notification-heading">Adam Smith</div>
                                            <div className="notification-timestamp">08 Hours ago</div>
                                            <div className="notification-text">Can you do me a favour?</div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript:void()">
                                        <img className="float-left mr-3 avatar-img" src="assets/images/avatar/3.jpg" alt="" />
                                        <div className="notification-content">
                                            <div className="notification-heading">Barak Obama</div>
                                            <div className="notification-timestamp">08 Hours ago</div>
                                            <div className="notification-text">Hi Teddy, Just wanted to let you ...</div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript:void()">
                                        <img className="float-left mr-3 avatar-img" src="assets/images/avatar/4.jpg" alt="" />
                                        <div className="notification-content">
                                            <div className="notification-heading">Hilari Clinton</div>
                                            <div className="notification-timestamp">08 Hours ago</div>
                                            <div className="notification-text">Hello</div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                            
                        </div>
                    </div>
                </li>
                <li className="icons dropdown"><a href="javascript:void(0)" data-bs-toggle="dropdown">
                        <i className="mdi mdi-bell-outline"></i>
                        <span className="badge badge-pill gradient-2">3</span>
                    </a>
                    <div className="drop-down animated fadeIn dropdown-menu dropdown-notfication">
                        <div className="dropdown-content-heading d-flex justify-content-between">
                            <span className="">2 New Notifications</span>  
                            <a href="javascript:void()" className="d-inline-block">
                                <span className="badge badge-pill gradient-2">5</span>
                            </a>
                        </div>
                        <div className="dropdown-content-body">
                            <ul>
                                <li>
                                    <a href="javascript:void()">
                                        <span className="mr-3 avatar-icon bg-success-lighten-2"><i className="icon-present"></i></span>
                                        <div className="notification-content">
                                            <h6 className="notification-heading">Events near you</h6>
                                            <span className="notification-text">Within next 5 days</span> 
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript:void()">
                                        <span className="mr-3 avatar-icon bg-danger-lighten-2"><i className="icon-present"></i></span>
                                        <div className="notification-content">
                                            <h6 className="notification-heading">Event Started</h6>
                                            <span className="notification-text">One hour ago</span> 
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript:void()">
                                        <span className="mr-3 avatar-icon bg-success-lighten-2"><i className="icon-present"></i></span>
                                        <div className="notification-content">
                                            <h6 className="notification-heading">Event Ended Successfully</h6>
                                            <span className="notification-text">One hour ago</span>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript:void()">
                                        <span className="mr-3 avatar-icon bg-danger-lighten-2"><i className="icon-present"></i></span>
                                        <div className="notification-content">
                                            <h6 className="notification-heading">Events to Join</h6>
                                            <span className="notification-text">After two days</span> 
                                        </div>
                                    </a>
                                </li>
                            </ul>
                            
                        </div>
                    </div>
                </li> */}
                
                <li className="icons dropdown">
                    <div className="user-img c-pointer position-relative"   data-bs-toggle="dropdown">
                        {/* <span className="activity active"></span> */}
                        <span className={`activity ${availability?.toLowerCase().replace(/\s+/g, '-') || ''}`}></span>

                        {/* <img src="assets/images/user/1.png" height="40" width="40" alt=" "/> */}
                        {profilePic ? (
                          <img
                            src={profilePic}
                            alt="Profile"
                            height="40" width="40"
                          />
                        ) : (
                          <i className="fa fa-user text-muted fa-2x" />
                        )}
                    </div>
                    <div className="drop-down dropdown-profile animated fadeIn dropdown-menu">
                        <div className="dropdown-content-body">
                            <ul>
                                <li>
                                    <a href={profileURL}><i className="icon-user"></i> <span>Profile</span></a>
                                </li>
                                {/* <li>
                                    <a href="javascript:void()">
                                        <i className="icon-envelope-open"></i> <span>Inbox</span> <div className="badge gradient-3 badge-pill gradient-1">3</div>
                                    </a>
                                </li> */}
                                
                                <hr className="my-2" />
                                {/* <li>
                                    <a href="page-lock.html"><i className="icon-lock"></i> <span>Lock Screen</span></a>
                                </li> */}
                                <li><button onClick={logOut} style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}><i className="icon-key"></i>&nbsp;<span>Logout</span></button></li>
                            </ul>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>
</>
  );
};

const menuItems = [
    { label: "Dashboard", link: "/home" },
    { label: "Profile", link: profileURL },
    {
    label: "Job Search",
    subItems: [
        { label: "Find Jobs", link: "/search" },
        { label: "Advanced Search", link: "/advanced-search" },
        // { label: "Recommended Jobs", link: "/recommended-jobs" }
    ]
    },

    // {
    //   label: "Applications",
    //   subItems: [
    //     { label: "My Applications", link: "/my-applications" },
    //     { label: "Application Status", link: "/application-status" }
    // ]
    // },
    {
      label: "Saved Jobs & Alerts",
      subItems: [
        { label: "Saved Jobs", link: "/saved-jobs" },
        // { label: "Job Alerts", link: "/job-alerts" }
      ]
    },
    // {
    //   label: "Interviews & Assessments",
    //   subItems: [
    //     "Scheduled Interviews",
    //     "Live Interviews",
    //     "Pre-Recorded Interviews",
    //     "Skill Assessments",
    //   ],
    // },
    // {
    //   label: "Notifications & Messages",
    //   subItems: ["Email & SMS Alerts", "In-App Notifications", "Messages"],
    // },
    // {
    //   label: "Referrals & Rewards",
    //   subItems: ["Refer & Earn", "Referral History"],
    // },
    // {
    //   label: "Premium & Subscription",
    //   subItems: ["Upgrade to Premium", "Subscription Plans", "Payment History"],
    // },
  ];
  

export default Header;
